import { http } from '@/utils/plugins/http'

export const getRoles = () => http.get('companies/fetch_roles');

export const inviteUser = (payload) => http.post('company_users/invite_user', payload);

export const getCompanyUsers = (id) => http.get(`companies/${id}/users`)


